import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import SolarHero from './components/SolarHero';
import SolarServices from './components/SolarServices';
import SolarSystemsElPaso from './components/SolarSystemsElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import SolarFAQ from './components/SolarFAQ';

export default function SolarPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <SolarHero />
        <SolarServices />
        <SolarSystemsElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <SolarFAQ />
      </main>
      <Footer />
    </div>
  );
}
